const localisations = {
    nodeDetails: {
        buttons: {
            saveChangesButtonText: "Save Changes",
            saveChildButtonText: "Save Child",
            deleteButtonText: "Delete",
            editDetailsButtonText: "Edit Details",
            cancelChangesButtonText: "Cancel Changes",
            addChildNodeButtonText: "Add child node",
            cancelDeleteButtonText: "Cancel",
            confirmDeleteButtonText: "Delete",
        },
        fields: {
            nodeName: {
                labelText: "Node Name",
                helperText: "Enter a name for the node",
            },
            nodeReference: {
                labelText: "Node Reference",
                helperText: "Enter a reference for the node",
            },
            allowPartions: {
                helperText: "Allow Partitions to be associated with node",
                yesText: "Yes",
                noText: "No",
            },
        },
        components: {
            editableNodeDetails: "Edit Node Details",
            readOnlyNodeDetails: "View Node Details",
            createChildNode: "Create Child Node",
        },
        headerText: "Node Details",
        deleteDialog: {
            title: "Delete Node",
            contentText: "Are you sure you want to delete",
        },
        addChildNodeForm: {
            headerText: "This will add a child node to",
        },
        pleaseSelecteDetailsText: "Please select node details",
        messages: {
            updatedNodeSuccess: "Successfully updated node",
            updatedNodeError: "Failed to update node",
            createdChildeSuccess: "Successfuly created child node",
            createdChildeError: "Failed to create child node",
            deletedNodeSuccess: "Successfully deleted node",
            deletedNodeError: "Failed to delete node",
        },
        tooltips: {
            noPartitionsAllowed: "No partitions are allowed to be associated to this node.",
        },
        serverErrors: {
            Id: {
                HierarchyNodeInUse: "This node has partitions associated with it.",
            },
            Name: {
                Required: "Node Name is required.",
                MinLength: "Node Name is too short.",
                MaxLength: "Node Name is too long.",
            },
            Reference: {
                MaxLength: "Node Reference is too long.",
                DuplicateValue: "An existing node already has this reference.",
            },
        },
    },
};

export default localisations;
